import React from "react";
import { Modal, Box } from "@mui/material";
import X from "./icons/x.svg";

import { useModalStore } from "../zustand/modal";
//components
import ImageSlider from "./ImageSlider";

// 전역 모달
export default function PtsModal(props) {
  const { is_open, data, closeModal } = useModalStore();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 640,
    bgcolor: "background.paper",
    border: "1px solid #000",
    boxShadow: 24,
    p: "30px 0",
  };

  return (
    <Modal open={is_open} onClose={closeModal}>
      <Box sx={style}>
        <div style={{ position: "relative" }}>
          <button
            style={{
              position: "absolute",
              right: -80,
              top: -30,
              background: "inherit",
            }}
            onClick={closeModal}
          >
            <img src={X} alt="" />
          </button>
        </div>
        <h5
          style={{
            padding: "0 40px 16px 40px",
            fontSize: 24,
            fontFamily: "spoqa_regular",
          }}
        >
          {data?.text}
        </h5>
        <ImageSlider
          imgSrcList={data?.image_src}
          slideWidth="100%"
          slideHeight="400px"
        />
        <div style={{ padding: "30px 40px" }}>
          {typeof data?.desc === "string" ? (
            <p
              style={{
                fontSize: 14,
                fontFamily: "spoqa_regular",
              }}
            >
              {data?.desc}
            </p>
          ) : (
            data?.desc?.map((text, idx) => (
              <p
                style={{
                  marginBottom: data.desc.length - 1 === idx ? 0 : 15,
                  fontSize: 14,
                  fontFamily: "spoqa_regular",
                }}
              >
                {text}
              </p>
            ))
          )}
        </div>
      </Box>
    </Modal>
  );
}
